<template>
  <div>
    <l-tables
      :tableConfig="tableConfig"
      ref="childRef"
      :searchParams="searchData"
      :noCreatText="$t('admin.appointment.noCreatText')"
      :ImgSrc="nullImg"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <a-input
          v-model="keyword"
          @change="search"
          maxlength="30"
          :placeholder="$t('admin.appointment.searchPlaceholder')"
        >
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img
            class="clear"
            v-if="keyword"
            slot="suffix"
            @click=";(keyword = undefined), search()"
            :src="require('@/assets/icons/icon_gb.png')"
          />
        </a-input>
      </template>
      <!--      预约时间-->
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <a-date-picker @change="onChange" />
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="calendar"
        :style="{ color: filterIconState ? '#FFA000' : '' }"
      />
      <div
        slot="filterDropdowns"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <a-date-picker @change="onChanges" />
      </div>
      <!--      创建时间-->
      <a-icon
        slot="filterIcons"
        slot-scope="filtered"
        type="calendar"
        :style="{ color: filterIconsState ? '#FFA000' : undefined }"
      />
      <template #statusNameMore="{ record }">
        <span style="color: #F06321" v-if="record.status == 1">{{ $t('admin.appointment.statusTypes.pending') }}</span>
        <span style="color: #2DB58B" v-if="record.status == 2">{{ $t('admin.appointment.statusTypes.approved') }}</span>
        <span style="color: #B00B0B" v-if="record.status == 3">{{ $t('admin.appointment.statusTypes.rejected') }}</span>
        <span style="color: #666666" v-if="record.status == 4">{{
          $t('admin.appointment.statusTypes.cancelled')
        }}</span>
      </template>
      <template #remark="{ record }">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ record.remark !== '' ? record.remark : $t('admin.appointment.defaultRemark') }}</span>
          </template>
          <span class="remark_cla">{{
            record.remark !== '' ? record.remark : $t('admin.appointment.defaultRemark')
          }}</span>
        </a-tooltip>
      </template>
      <template #operates="{ record }">
        <div class="operate">
          <a-button type="link" v-if="record.status == 1" style="padding-right: 0" @click="approvalModel(record)">
            {{ $t('admin.appointment.actions.approval') }}
          </a-button>
          <a-button type="link" @click="seeClick(record.id)">
            {{ $t('admin.appointment.actions.view') }}
          </a-button>
        </div>
      </template>
    </l-tables>
    <a-modal width="515px" :visible="editShow" @ok="submitEdit" @cancel="editShow = false">
      <a-form :form="formEdit">
        <a-form-item class="full marginBottom0" :label="$t('admin.appointment.approvalModal.opinion')" :colon="false">
          <a-radio-group
            class="radioGroup"
            @change="changeColor('navigateBackground')"
            v-decorator="[
              'status',
              { rules: [{ required: true, message: $t('admin.appointment.approvalModal.opinionRequired') }] }
            ]"
          >
            <a-radio :value="2">{{ $t('admin.appointment.approvalModal.approve') }}</a-radio>
            <a-radio :value="3">{{ $t('admin.appointment.approvalModal.reject') }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item class="full marginBottom0" :label="$t('admin.appointment.approvalModal.remark')" :colon="false">
          <a-textarea
            maxLength="100"
            :disabled="!isRequired"
            style="height:160px;width: 448px"
            :placeholder="$t('admin.appointment.approvalModal.remarkPlaceholder')"
            v-decorator="[
              'remark',
              { rules: [{ required: isRequired, message: $t('admin.appointment.approvalModal.remarkRequired') }] }
            ]"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import {
  getTeacherListAll,
  getTrainingRoomUsableList,
  postTrainingRoomApplyRatify,
  postTrainingRoomApplySave
} from '@/api/admin'
let att = []
export default {
  components: {
    LTables
  },
  data() {
    return {
      noCreatText: this.$t('admin.appointment.noCreatText'),
      nullImg: require('@/assets/img/trainningAppointmentListNull.png'),
      keyword: undefined,
      searchData: {
        theme: ''
      },
      tableConfig: {
        tableName: this.$t('admin.appointment.title'),
        tableColumns: [
          {
            title: this.$t('admin.appointment.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80
          },
          {
            title: this.$t('admin.appointment.trainingRoom'),
            dataIndex: 'trainingRoomName',
            key: 'trainingRoomName',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: []
          },
          {
            title: this.$t('admin.appointment.applicant'),
            dataIndex: 'teacherName',
            key: 'teacherName',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: []
          },
          {
            title: this.$t('admin.appointment.appointmentTime'),
            dataIndex: 'reservationAt',
            key: 'reservationAt',
            align: 'center',
            wdith: 180,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            }
          },
          {
            title: this.$t('admin.appointment.theme'),
            dataIndex: 'theme',
            key: 'theme',
            align: 'center',
            wdith: 300
          },
          {
            title: this.$t('admin.appointment.status'),
            dataIndex: 'statusNameMore',
            key: 'statusNameMore',
            align: 'center',
            width: 120,
            scopedSlots: { customRender: 'statusNameMore' },
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.appointment.statusTypes.pending'), value: '1' },
              { text: this.$t('admin.appointment.statusTypes.approved'), value: '2' },
              { text: this.$t('admin.appointment.statusTypes.rejected'), value: '3' },
              { text: this.$t('admin.appointment.statusTypes.cancelled'), value: '4' }
            ]
          },
          {
            title: this.$t('admin.appointment.applyTime'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center',
            scopedSlots: {
              filterDropdown: 'filterDropdowns',
              filterIcon: 'filterIcons',
              customRender: 'customRender'
            }
          },
          {
            title: this.$t('admin.appointment.approvalOpinion'),
            dataIndex: 'remark',
            key: 'remark',
            align: 'center',
            wdith: 400,
            scopedSlots: { customRender: 'remark' }
          },
          {
            title: this.$t('admin.appointment.operations'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tableDeleteTip: {
          title: '确定要删除该老师？',
          content: '删除后老师下的班级和学生数据将全部清空'
        },
        tablePort: {
          list: '/training_room_apply/list',
          del: '/teacher/delete'
        }
      },
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      roomList: [],
      teachList: [],
      subDate: {}, //预约时间
      createdDate: {}, //创建时间
      filterResult: {},
      editShow: false,
      formEdit: this.$form.createForm(this),
      isRequired: false,
      filterIconsState: false,
      filterIconState: false,
      id: '',
      one: false
    }
  },
  mounted() {
    this.getTrainingRoomUsableListHttp()
    this.getTeacherListAllHttp()
  },
  methods: {
    search() {
      this.searchData.theme = this.keyword
    },
    create() {
      this.$router.push({
        name: 'teacherAdd'
      })
    },
    approvalModel(item) {
      this.editShow = true
      this.id = item.id
      this.formEdit.setFieldsValue({
        status: 0,
        remark: ''
      })
    },
    seeClick(id) {
      console.log(id)
      this.$router.push({
        name: 'appointmentListDetail',
        query: {
          id: id
        }
      })
    },
    onChange(value, dateString) {
      if (dateString !== '') {
        this.subDate = {
          subDate: dateString
        }
        this.filterResult.subDate = dateString
        this.filterIconState = true
      } else {
        this.subDate = {}
        delete this.filterResult.subDate
        this.filterIconState = false
      }

      let param = { ...this.filterResult, ...this.createdDate }
      this.$refs.childRef.getList({ condition: param })
    },
    onChanges(value, dateString) {
      if (dateString !== '') {
        this.createdDate = {
          createdDate: dateString
        }
        this.filterResult.createdDate = dateString
        this.filterIconsState = true
      } else {
        this.filterIconsState = false
        this.createdDate = {}
        delete this.filterResult.createdDate
      }
      let param = { ...this.filterResult, ...this.createdDate }
      this.$refs.childRef.getList({ condition: param })
    },
    onOk(value) {
      console.log('onOk: ', value)
    },
    // 所有实训室
    async getTrainingRoomUsableListHttp() {
      const res = await getTrainingRoomUsableList()
      if (res.code == 200) {
        for (let item of res.data.list) {
          this.roomList.push({
            name: item.name,
            id: item.id
          })
        }
        this.tableConfig.tableColumns[1].filters = this.roomList.map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
      }
    },
    // 所有老师
    async getTeacherListAllHttp() {
      const res = await getTeacherListAll()
      if (res.code == 200) {
        for (let item of res.data.list) {
          this.teachList.push({
            name: item.name,
            id: item.id
          })
        }
        this.tableConfig.tableColumns[2].filters = this.teachList.map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
      }
    },
    handleTableHeaderChange([filters, getList, sorter]) {
      console.log(this.subDate)
      let result = {}
      result = {
        ...{ trainingRoomIds: filters.trainingRoomName },
        ...{ statuses: filters.statusNameMore },
        ...{ teacherIds: filters.teacherName },
        ...this.subDate,
        ...this.createdDate
      }
      console.log(result)
      this.filterResult = result
      getList({ condition: result })
    },
    // 审批弹框确定
    submitEdit() {
      this.formEdit.validateFields(async (err, values) => {
        if (!err) {
          let param
          if (values.status == 2) {
            param = {
              status: values.status,
              id: this.id
            }
          } else {
            param = { ...values, ...{ id: this.id } }
          }
          const res = await postTrainingRoomApplyRatify(param)
          if (res.code === 200) {
            this.editShow = false
            this.$refs.childRef.getList()
          }
        }
      })
    },
    changeColor(key) {
      setTimeout(() => {
        if (this.formEdit.getFieldValue('status') == 2) {
          this.isRequired = false
        } else {
          this.isRequired = true
        }
      })

      this.formEdit[key] = this[key + 'Has'] ? '#ffffff' : ''
      this.isRequired = !this.isRequired
    }
  }
}
</script>

<style lang="less" scoped>
.l-form {
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
    width: 250px;
    line-height: 30px;
  }
  .ant-form-item-label {
    margin-top: 10px;
  }
}
/deep/ .ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  right: auto !important;
  top: -1px;
  color: #7e869c;
  position: absolute !important;
}
.remark_cla {
  max-width: 200px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
/deep/.ant-modal-wrap .ant-modal .ant-input {
  resize: none; /* 禁止用户手动拖动调整大小 */
}
/deep/ .ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 319px !important;
  overflow-x: auto !important;
}
.marginBottom0 {
  margin-bottom: 0;
}
/deep/ .ant-form-item-children {
  textarea {
    width: 100% !important;
  }
}
</style>
